import { withNamespaces } from "react-i18next";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const ResumeWorkflowModal = ({ t, isOpen, isLoading, onClose, onConfirm }) => {
  const handleClose = () => {
    if (isLoading) {
      return;
    }
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleClose}
      centered
      size="md"
      backdrop={isLoading ? "static" : true}
    >
      <ModalHeader toggle={handleClose}>{t("Resume Workflow")}</ModalHeader>
      <ModalBody>
        <p className="mb-2">
          {t(
            "Are you sure you want to end the waiting period and resume the deadline countdown?"
          )}
        </p>
        <p className="text-muted mb-0">
          {t(
            "The elapsed waiting time will be included in the effective deadline."
          )}
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={handleClose} disabled={isLoading}>
          {t("Cancel")}
        </Button>
        <Button color="primary" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? t("Loading...") : t("Confirm")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default withNamespaces()(ResumeWorkflowModal);
